import { isDateInNextDays } from 'dateUtils';
import { DataRoomShareableLink } from 'models/ShareableLink';

export const getRowBackgroundColor = (link: DataRoomShareableLink) => {
  const { isActive, linkExpiresDate, totalAccessCount } = link;

  return isActive && linkExpiresDate && isDateInNextDays(linkExpiresDate, 7)
    ? 'expires-soon-row'
    : totalAccessCount
    ? 'analytics-row'
    : '';
};
